<h5 class="mb-4">Myrealkorean Privacy Policy</h5>
<p class="fs-10">
        MyRealKorean(이하 "회사"라 함)는 회원들의 개인정보보호를 매우 중요시하며, 회원이 회사의 MyRealKorean 애플리케이션 및 MyRealKorean 관련 서비스(이하 "서비스"라 함)를 이용함과 동시에 온라인상에서 회사에 제공한 개인정보가 보호 받을 수 있도록 최선을 다하고 있습니다.
        <br><br>이에 회사는 통신비밀보호법, 전기통신사업법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 정보통신서비스제공자가 준수하여야 할 관련 법규상의 개인정보보호 규정 및 정보통신부가 제정한 개인정보보호지침을 준수하고 있습니다. 
        <br>
        <br>회사는 개인정보처리방침을 통하여 회원들이 제공하는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.
        <br>
        <br>1. 개인정보의 수집목적 및 이용목적
        <br>개인정보란 생존하는 개인에 관한 정보로서 당해 개인을 식별할 수 있는 정보(당해 정보만으로는 특정 개인을 식별할 수 없더라도 다른 정보와 용이하게 결합하여 식별할 수 있는 것을 포함함)를 말합니다. 
        <br>회사가 회원님 개인의 정보를 수집하는 목적은 회원님께 최적의 서비스를 제공해드리기 위한 것입니다. 
        <br>회사는 각종의 콘텐츠를 무료로 서비스해 드리고 있습니다. 이때 회원님께서 제공해주신 개인정보를 바탕으로 회원님께 보다 더 유용한 정보를 선택적으로 제공하는 것이 가능하게 됩니다.
        <br>
        <br>2. 입력받는 개인정보 항목 및 수집방법
        <br>회사는 회원가입 시 원활한 서비스 제공을 위해 개인정보를 받고 있습니다.
        
        <br>회원가입 : 이름, 이메일, 비밀번호, 관심분야
        
        <br>모든 개인정보는 암호화하여 저장되며 회원에 의해 공개되지 않는 항목들은 다른 서비스에 이용되거나 다른 회원에 의해 열람되지 않습니다.
        
        <br><br>3. 개인정보 수집에 대한 동의
        회사는 회원님의 개인정보 수집에 대하여 동의를 받고 있으며, 회사 내의 회원가입 절차 중 이용약관 및 개인정보처리방침에 개인정보 수집 동의절차를 마련해 두고 있습니다. 
        회원님께서 이용약관 동의란에 체크하시면 개인정보 수집에 대해 동의한 것으로 간주합니다.
        
        <br><br>4. 개인정보의 제공 및 공유
        회사는 그 외 회원님의 동의가 있거나 법률의 규정에 의한 경우를 제외하고는 어떠한 경우에도 "2. 입력받는 개인정보 항목 및 수집방법"에서 고지한 범위를 넘어서 회원님의 개인정보를 이용하거나 타인 또는 타기업, 기관에게 제공하지 않습니다.
        회사는 회원님의 개인정보를 제3자에게 제공하거나 공유하는 경우에는 사전에 회원님께 개인정보를 제공받거나 공유하게 될 자가 누구이며, 제공 또는 공유되는 개인정보항목이 무엇인지, 왜 그러한 개인정보가 공유되어야 하는지, 그리고 언제까지 어떻게 보호, 관리되는지에 대해 개별적으로 전자우편 또는 회사 서비스 내의 공지사항을 통해 고지하여 동의를 구하는 절차를 거치거나, 회원가입 시 별도로 동의를 구할 수도 있습니다. 
        회원님이 동의하지 않는 경우에는 개인정보를 제공하거나 공유하지 않습니다. 
        제공관계에 변화가 있거나 제공관계가 종결될 때도 같은 절차에 의하여 고지하거나 동의를 구합니다. 
        다만, 다음의 경우에는 예외적으로 회원님의 동의 없이 개인정보를 제공할 수 있습니다.
        <br>- 법령의 규정에 의거하거나, 수사상 목적으로 법령에 정해진 절차와 방법에 따라 관련기관의 요구가 있는 경우
        <br>- 통계작성, 학술연구 또는 시장조사를 위하여 개인을 식별할 수 없는 형태로 제공하는 경우
        
        <br><br>5. 개인정보 열람, 정정
        회원님은 언제든지 등록되어 있는 회원님의 개인정보를 열람하거나 정정을 요청하실 수 있습니다.
        회원님 개인 정보의 열람 및 정정은 회사 서비스 로그인 후 '정보수정' 메뉴를 통하여 직접 열람 또는 정정하실 수 있습니다.
        회사는 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다.
        
        <br><br>6. 개인정보의 보유 및 이용기간
        회사는 회원가입일로부터 회원탈퇴와 같은 개인정보 수집, 이용, 제공에 대한 동의 철회 시까지 회원님의 개인정보를 보유 및 이용하게 됩니다.
        동의,철회는 회사 서비스의 로그인 후 '정보수정' 메뉴 내의 '탈퇴'를 클릭하신 다음 정해진 순서에 따라 동의철회를 하시면 즉시 회원탈퇴가 완료되며 회원님의 개인정보를 파기하는 등 필요한 조치를 취합니다.
        단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다.
        <br><br>- 보존 항목: 이메일, 닉네임, 개인식별용 키값
        <br>- 보존 근거: 불법적 사용자에 대한 관련 기관 수사협조
        <br>- 보존 기간: 3개월
        
        <br><br>그리고 관계법령의 규정에 의하여 보존할 필요가 있는 경우 회사는 아래와 같이 관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다.
        <br>- 보존 항목: 이용자 접속 정보(회원 가입 시 IP, 최종 접속 시간)
        <br>- 보존 근거: 통신비밀보호법
        <br>- 보존 기간: 3개월
        <br>- 표시/광고에 관한 기록: 6개월 (전자상거래등에서의 소비자보호에 관한 법률)
        <br>- 계약 또는 청약철회 등에 관한 기록: 5년 (전자상거래등에서의 소비자보호에 관한 법률)
        <br>- 대금결제 및 재화 등의 공급에 관한 기록: 5년 (전자상거래등에서의 소비자보호에 관한 법률)
        <br>- 소비자의 불만 또는 분쟁처리에 관한 기록: 3년(전자상거래등에서의 소비자보호에 관한 법률)
        
        <br><br>7. 개인정보의 파기절차 및 방법회사의 개인정보 파기절차 및 방법은 다음과 같습니다.
        <br>파기절차
        <br>- 이용자가 회원가입 등을 위해 입력한 정보는 목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(개인정보의 보유 및 이용기간 참조) 일정 기간 저장된 후 파기되어 집니다.
        <br>- 별도 DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 다른 목적으로 이용되지 않습니다.
        <br>파기방법
        <br>- 전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.
        <br>- 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.
        
        <br><br>8. 개인정보 보관 및 보호를 위한 기술적, 관리적 대책
        회원님의 개인정보는 비밀번호에 의해 보호되고 있습니다. 회원님 계정의 비밀번호는 오직 본인만이 알 수 있으며, 개인정보의 확인 및 변경도 비밀번호를 알고 있는 본인에 의해서만 가능합니다. 
        따라서 회원님의 비밀번호는 누구에게도 알려주면 안됩니다. 또한 작업을 마치신 후에는 로그아웃(log-out)하시고 애플리케이션을 종료하는 것이 바람직합니다. 
        특히 다른 사람과 컴퓨터를 공유하여 사용하거나 공공장소에서 이용한 경우 개인정보가 다른 사람에게 알려지는 것을 막기 위해서 이와 같은 절차가 더욱 필요하다고 하겠습니다.
        회사는 개인정보 처리 직원을 최소한으로 제한하고 담당직원에 대한 수시 교육을 통하여 본 정책의 준수를 강조하고 있으며, 내부적인 점검을 통해 본 정책의 이행사항 및 담당직원의 준수여부를 확인하여 문제가 발견될 경우 바로 시정조치하고 있습니다.
        회사의 개인정보보호를 위한 기술적, 관리적 대책은 다음과 같습니다.
        <br>
        <br>1) 컴퓨터 바이러스에 의한 개인정보의 침해를 방지하기 위하여 백신프로그램을 이용하며 주기적인 업데이트를 통해 새로운 바이러스에 대비하고 있습니다.
        <br>2) 개인정보에 대한 직접적인 접근을 방지하기 위하여 데이터베이스의 보안기능을 이용하여 일부 정보는 열람할 수 없도록 하고 있습니다.
        <br>3) 인터넷망을 통한 해커의 불법적 침입에 대비하여 방화벽과 침입탐지 시스템을 사용하여 보안에 만전을 기하고 있습니다.
        <br>4) 개인정보에 대한 접근권한을 개인정보보호 책임자 등 개인정보관리업무를 수행하는 자, 기타 업무상 개인정보의 처리가 불가피한 자로 제한하며, 그 이외의 인원이 개인정보에 접근하는 것을 허용하지 않습니다.
        <br>5) 개인정보와 일반 데이터를 혼합하여 탑재하지 않으며, 별도의 계정을 통하여 관리하고 있습니다.
        <br>6) 시스템적으로 보안성을 확보하기 위해 가능한 모든 기술적 장치를 갖추려 노력하고 있습니다.
        <br><br>
        9. 개인정보보호 책임자회원님의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 회사는 개인정보보호 책임자를 두고 있습니다. 회원님의 개인정보와 관련한 문의사항이 있으시면 아래의 개인정보보호 책임자 또는 개인정보보호 담당자에게 연락 주시기 바랍니다.
        <br>개인정보보호 책임자, 담당자
        <br><br>- 이름 : 조영미
        <br>- 소속 : myrealkorean
        <br>- 직위 : 대표
        <br>- 메일 : myrealkorean@gmail.com
        <br>
        <br>- 개인정보처리방침 공고일자 : 2019년 06월 01일
        <br>- 개인정보처리방침 시행일자 : 2019년 09월 01일

</p>
